// HomeDistributionBar.js
// Flex-grow segments in a rounded track. A Home-primitive port of the
// pattern at lessonPlans/teachsense/TeachSenseMastery.js:35-70 -- not
// imported from there, since this is a Home primitive built on Home tokens.
// No SVG library is declared in this project (react-native-svg resolves
// only as an undeclared transitive peer of react-native-copilot), so this
// is plain Views only.
// See docs/superpowers/specs/2026-09-29-home-finish.md §F4a.
import React from "react";
import { View, StyleSheet } from "react-native";

import { homeColors } from "../homeTheme";

const HomeDistributionBar = ({
  segments = [],
  isDarkMode = false,
  testID,
  accessibilityLabel,
}) => {
  const colors = homeColors(isDarkMode);
  const survivors = (segments || []).filter((segment) => Number(segment?.count) > 0);
  const total = survivors.reduce((sum, segment) => sum + Number(segment.count), 0);

  return (
    <View
      testID={testID}
      accessibilityRole="progressbar"
      accessibilityLabel={accessibilityLabel}
      style={[
        styles.track,
        total > 0
          ? null
          : { borderWidth: 1, borderColor: colors.line, backgroundColor: colors.surfaceElevated },
      ]}
    >
      {total > 0
        ? survivors.map((segment) => (
            <View
              key={segment.key}
              testID={`${testID}-${segment.key}`}
              style={[styles.segment, { flexGrow: Number(segment.count), backgroundColor: segment.color }]}
            />
          ))
        : null}
    </View>
  );
};

const styles = StyleSheet.create({
  track: { height: 8, borderRadius: 999, overflow: "hidden", flexDirection: "row" },
  segment: { flexBasis: 0, minWidth: 2 },
});

export default HomeDistributionBar;
